module.exports = __webpack_public_path__ + "3e367c8d03e5752798391aaf879f2e68.svg";